import React from 'react';
import { ContactLink, ServiceIcon } from './HomeUI';

const projects = [
  { icon: 'ai', title: 'Artificial intelligence & automation', description: 'Our project experience includes AI solutions that bring intelligence into business workflows and connect it to the software teams already use.', tags: ['AI-enabled workflows', 'Business automation'] },
  { icon: 'enterprise', title: 'Software that powers operations', description: 'Sophisticated internal software helps teams manage complex work, connect systems, and make information usable across the organization.', tags: ['Internal platforms', 'Systems integration'] },
  { icon: 'applications', title: 'Products built for your customers', description: 'Consumer-facing web and mobile applications turn complex capabilities into clear, useful experiences for the people on the other side of the screen.', tags: ['Web experiences', 'iOS & Android'] }
];

export default function SectionThree() {
  return <section className="home-section home-projects">
    <div className="home-container">
      <div className="home-section-heading">
        <p className="home-eyebrow">Project experience</p>
        <h2>From internal operations<br />to customer experiences.</h2>
        <p>Our work spans AI, enterprise systems, and consumer-facing products. We match each engagement with experienced specialists in the architecture, platforms, and engineering disciplines it requires.</p>
      </div>
      <div className="home-project-grid">
        {projects.map(project => <article className="home-project-card" key={project.title}>
          <ServiceIcon name={project.icon} />
          <h3>{project.title}</h3><p>{project.description}</p>
          <ul className="home-tags">{project.tags.map(tag => <li key={tag}>{tag}</li>)}</ul>
        </article>)}
      </div>
      <div className="home-portfolio-strip">
        <div><p className="home-eyebrow">One business. An entire portfolio.</p><h3>Technology shaped around your operating goals.</h3><p>For private equity groups, we assess company-level needs and shared opportunities, prioritize investments, and plan implementation across the portfolio while respecting each company’s data boundaries.</p></div>
        <ContactLink light>Discuss your priorities</ContactLink>
      </div>
    </div>
  </section>;
}
